@if (confirmService.state$ | async; as dialog) {
  <div class="confirmOverlay" (click)="onOverlayClick()">
    <div class="confirmCard" (click)="$event.stopPropagation()">
      <div class="confirmHeader">
        <h3>{{ dialog.title }}</h3>
      </div>

      <div class="confirmBody">
        <p>{{ dialog.message }}</p>
      </div>

      <div class="confirmActions">
        <button type="button" class="btnCancel" (click)="onCancel()">
          {{ dialog.cancelText }}
        </button>

        <button
          type="button"
          class="btnConfirm"
          [class.warning]="dialog.variant === 'warning'"
          [class.danger]="dialog.variant === 'danger'"
          [class.info]="dialog.variant === 'info'"
          (click)="onConfirm()"
        >
          {{ dialog.confirmText }}
        </button>
      </div>
    </div>
  </div>
}